<template>
  <!-- Start Cookie Popup -->
  <div v-show="showBanner" class="cookie-popup border-2 fixed max-w-xl bottom-3 right-3 left-3 sm:left-0 sm:right-0 mx-auto bg-white dark:bg-slate-900 shadow-md dark:shadow-md-gray-800 rounded-md py-5 px-6 z-50">
    <p class="_text-slate-400">Un client satisfait peut générer beaucoup d'autres . Écoutez-les attentivement dès aujourd'hui. <a href="/cookies" target="_blank"
        class="text-emerald-600 dark:text-emerald-500 font-semibold">Démo.</a></p>
    <div class="cookie-popup-actions text-right">
      <button @click="hideBanner" class="absolute border-none bg-none p-0 cursor-pointer font-semibold top-2 right-2"><i
          class="uil uil-times text-dark dark:text-slate-200 text-2xl"></i></button>
    </div>
  </div>
  <!--Note: Cookies Js including in plugins.init.js (path like; assets/js/plugins.init.js) and Cookies css including in _helper.scss (path like; scss/_helper.scss)-->
  <!-- End Cookie Popup -->
</template>

<script>
export default {
  data() {
    return {
      showBanner: true
    }
  },
  methods: {
    hideBanner() {
      this.showBanner = false;
    }
  },
}
</script>

<style></style>